import React from 'react';
import { connect } from 'react-redux';
import { openNotification } from 'Actions/notification';
// import utils from 'Utils/commonUtil';

// Components
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
import Anchor from 'Components/common/Anchor';
import Counter from 'Components/counter/Counter';
import Input from 'Components/common/Input';
import SearchInput from 'Components/common/SearchInput';

class Demo extends React.Component {
    state = {
        dialogOpened: false,
        inputValue: 'default value'
    };

    successNotification = () => {
        this.props.openNotification('成功', 'success');
    }

    dangerNotification = () => {
        this.props.openNotification('警告', 'danger');
    }

    confirmNotification = () => {
        this.props.openNotification('确认', 'confirm');
    }

    openDialog = () => {
        this.setState({ dialogOpened: true });
    }

    handleChange = (title, value, ev) => {
        this.setState({ [title]: value });
    }

    render() {
        return (
            <div style={{ minHeight: '2000px' }}>
                <h3>通知(Notification)</h3>
                <br/>
                <div>
                    <BasicButton type="primary" onClickOfSingleTap={ this.successNotification }>Success</BasicButton>
                    <BasicButton type="info" onClickOfSingleTap={ this.dangerNotification }>Danger</BasicButton>
                    <BasicButton type="default" onClickOfSingleTap={ this.confirmNotification }>Confirm</BasicButton>
                </div>
                <br/>
                <h3>窗口(Dialog)</h3>
                <br/>
                <div>
                    <BasicButton type="info" onClickOfSingleTap={ this.openDialog }>打开窗口</BasicButton>
                    <Dialog opened={this.state.dialogOpened} dialogDidClose={() => this.setState({ dialogOpened: false })} options={{ bgClickClose: true }}>
                        <div style={{ minHeight: '1000px', background: '#FFF' }}>Dialog content</div>
                    </Dialog>
                </div>
                <br/>
                <h3>按钮(Unable Button Style)</h3>
                <br/>
                <div>
                    <BasicButton type="primary" disabled={false} onClickOfSingleTap={ () => alert('Click primary button') }>Primary</BasicButton>
                    <BasicButton type="info" disabled={false} onClickOfSingleTap={ () => alert('Click info button') }>Info</BasicButton>
                    <BasicButton type="default" disabled={false} onClickOfSingleTap={ () => alert('Click default button') }>Default</BasicButton>
                </div>
                <br/>
                <h3>按钮(Disabled Button Style)</h3>
                <br/>
                <div>
                    <BasicButton type="primary" disabled={true} onClickOfSingleTap={ () => alert('Click primary button') }>Primary</BasicButton>
                    <BasicButton type="info" disabled={true} onClickOfSingleTap={ () => alert('Click info button') }>Info</BasicButton>
                    <BasicButton type="default" disabled={true} onClickOfSingleTap={ () => alert('Click default button') }>Default</BasicButton>
                </div>
                <br/>
                <div>
                    <Counter options={{ min: 0, max: 10 }}></Counter>
                </div>
                <br/>
                <h3>锚点(Anchor)</h3>
                <br/>
                <div>
                    <Anchor className="a" onClickOfSingleTap={ () => alert('Click me') }>Click me</Anchor>
                </div>
                <br/>
                <h3>输入框(Input)</h3>
                <div>
                    <Input title="inputValue" value={ this.state.inputValue } onChange={ this.handleChange } />
                    <br/>
                    <SearchInput title="inputValue" value={ this.state.inputValue } onChange={ this.handleChange }/>
                </div>
            </div>
        );
    }
}

let mapStateToProps = state => {
    return {
    };
};

let mapDispatchToProps = {
    openNotification
};

export default connect(mapStateToProps, mapDispatchToProps)(Demo);
